import React, { useState } from 'react';
import { auth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from '../../firebase/config';

const AuthScreen = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleAuthAction = async (e) => {
        e.preventDefault();
        setError('');
        try {
            if (isLogin) {
                await signInWithEmailAndPassword(auth, email, password);
            } else {
                await createUserWithEmailAndPassword(auth, email, password);
            }
        } catch (err) {
            switch (err.code) {
                case 'auth/user-not-found':
                case 'auth/invalid-credential':
                    setError("Email ou mot de passe incorrect.");
                    break;
                case 'auth/wrong-password':
                    setError("Mot de passe incorrect.");
                    break;
                case 'auth/email-already-in-use':
                    setError("Cette adresse e-mail est déjà utilisée.");
                    break;
                case 'auth/weak-password':
                    setError("Le mot de passe doit contenir au moins 6 caractères.");
                    break;
                default:
                    setError("Une erreur est survenue. Veuillez réessayer.");
                    break;
            }
        }
    };

    return (
        <div className="flex min-h-screen bg-black">
            <div className="flex flex-col justify-center w-full lg:w-1/2 bg-black p-8 sm:p-12 md:p-16">
                <div className="w-full max-w-md mx-auto">
                    <h1 className="text-white text-5xl font-black mb-10 italic">MY SEMINAR.</h1>
                    <form onSubmit={handleAuthAction}>
                        <div className="mb-5">
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-400">E-mail</label>
                            <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 bg-[#1C1C1C] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500" placeholder="Entrez votre mail ici" required />
                        </div>
                        <div className="mb-5">
                            <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-400">Mot de passe</label>
                            <input type="password" id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 bg-[#1C1C1C] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500" placeholder="Entrez votre mot de passe ici" required />
                        </div>
                        {isLogin && (
                            <div className="text-right mb-8">
                                <a href="#" className="text-sm text-blue-400 hover:underline">Mot de passe oublié</a>
                            </div>
                        )}
                        {error && <p className="text-red-500 text-sm text-center my-4">{error}</p>}
                        <button type="submit" className="w-full bg-[#F25187] text-white font-bold py-3 px-4 rounded-lg hover:bg-pink-600 transition duration-300 ease-in-out">
                            {isLogin ? 'Se connecter' : 'Créer mon compte'}
                        </button>
                    </form>
                    <p className="text-center text-sm text-gray-400 mt-8">
                        {isLogin ? "Vous n’avez pas de compte ?" : "Vous avez déjà un compte ?"}
                        <button onClick={() => { setIsLogin(!isLogin); setError(''); }} className="font-medium text-blue-400 hover:underline ml-1">
                            {isLogin ? 'Créer un compte' : 'Se connecter'}
                        </button>
                    </p>
                </div>
            </div>
            <div className="hidden lg:block lg:w-1/2 bg-cover bg-center" style={{backgroundImage: "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2070&auto=format&fit=crop')"}}>
            </div>
        </div>
    );
};

export default AuthScreen;